import React, { useRef, useState } from 'react';
import './VideoShowcase.css';

const VideoShowcase = () => {
  const [currentVideo, setCurrentVideo] = useState(-1);
  const [isHorizontalPlaying, setIsHorizontalPlaying] = useState(false);
  const videoRefs = useRef([]);
  const horizontalVideoRef = useRef(null);

  const verticalVideos = [
    { id: 1, src: '/assets/video2.mp4', title: 'Collection Highlight 1', poster: '/assets/video1-thumb.jpg' },
    { id: 2, src: '/assets/video3.mp4', title: 'Collection Highlight 2', poster: '/assets/video2-thumb.jpg' },
    { id: 3, src: '/assets/video4.mp4', title: 'Collection Highlight 3', poster: '/assets/video3-thumb.jpg' },
    { id: 4, src: '/assets/video1.mp4', title: 'Behind the Scenes', poster: '/assets/video4-thumb.jpg' }
  ];

  const handlePlay = (index) => {
    videoRefs.current.forEach((v, i) => {
      if (v && i !== index) v.pause();
    });
    if (horizontalVideoRef.current) {
      horizontalVideoRef.current.pause();
      setIsHorizontalPlaying(false);
    }
    setCurrentVideo(index);
    const video = videoRefs.current[index];
    if (video) video.play();
  };

  const handlePause = (index) => {
    setCurrentVideo(-1);
  };

  const handleHorizontalPlay = () => {
    videoRefs.current.forEach((v) => {
      if (v) v.pause();
    });
    setCurrentVideo(-1);
    setIsHorizontalPlaying(true);
    if (horizontalVideoRef.current) horizontalVideoRef.current.play();
  };

  const handleHorizontalPause = () => {
    setIsHorizontalPlaying(false);
  };

  return (
    <section className="video-showcase">
      <div className="video-header">
        <h2 className="video-title">Collection in Motion</h2>
        <p className="video-subtitle">Experience the runway</p>
      </div>
      
      {/* Вертикальна сітка відео */}
      <div className="video-grid">
        {verticalVideos.map((video, index) => (
          <div 
            key={video.id} 
            className="video-container"
          >
            <video
              ref={el => videoRefs.current[index] = el}
              className="video-player"
              loop
              playsInline
              preload="metadata"
              controls
              poster={video.poster}
              onPlay={() => handlePlay(index)}
              onPause={() => handlePause(index)}
            >
              <source src={video.src} type="video/mp4" />
            </video>
            
            {currentVideo !== index && (
              <div 
                className="video-play-overlay"
                onClick={() => handlePlay(index)}
                style={{pointerEvents: 'auto'}}
              >
                <div className="play-button">▶</div>
              </div>
            )}
            
            <div className="video-info">
              <span className="video-number">{String(video.id).padStart(2, '0')}</span>
            </div>
          </div>
        ))}
      </div>

      {/* Горизонтальне відео на всю ширину */}
      <div className="horizontal-video-wrapper">
        <div className="horizontal-video-container">
          <video
            ref={horizontalVideoRef}
            className="horizontal-video-player"
            loop
            playsInline
            preload="metadata"
            controls
            poster="/assets/MEADEA_BY_THEO_thumb.jpg"
            onPlay={handleHorizontalPlay}
            onPause={handleHorizontalPause}
          >
            <source src="/assets/MEADEA_BY_THEO.mp4" type="video/mp4" />
          </video>
          
          {!isHorizontalPlaying && (
            <div 
              className="horizontal-video-overlay"
              onClick={handleHorizontalPlay}
            >
              <div className="horizontal-play-button">▶</div>
            </div>
          )}
          
          <div className="horizontal-video-info">
            <span className="video-number">05</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoShowcase;
